import { ChevronLeft } from 'lucide-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

type Props = {
  children: React.ReactNode;
  onBackClick: () => void;
  actionChildren?: React.ReactNode;
  onboardingProgress?: number;
};

const OnboardingLayout: React.FC<Props> = ({
  children,
  onBackClick,
  actionChildren,
  onboardingProgress = 0,
}) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col h-full p-5">
      <div className="fixed top-0 inset-x-0 flex flex-col bg-[#0a0118] mb-16 px-5 py-5 z-20">
        <div className="flex justify-between items-center pb-4">
          <ChevronLeft className="cursor-pointer" onClick={onBackClick} />
          <div className="text-white" onClick={() => navigate('/auth/login')}>
            Log in
          </div>
        </div>

        <div className="h-2 bg-gray-800 rounded-full">
          <div
            className="h-full bg-[#6000E9] rounded-full transition-all duration-300"
            style={{
              width: `${onboardingProgress}%`,
              transition: 'width 0.5s ease-in-out',
            }}
          ></div>
        </div>
      </div>

      <div className="flex-grow mt-[4rem]">{children}</div>

      <div className="fixed bottom-0 inset-x-0 p-5 w-full">
        {actionChildren}
      </div>
    </div>
  );
};

export default OnboardingLayout;
